import { HostListener, Injectable } from '@angular/core';
import { NavController, ToastController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ToastService {
  deleteParcel(): any {
    throw new Error('Method not implemented.');
  }


  constructor(
    private toastController: ToastController) { }

  async showToast(message: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
    });
    void toast.present();
  }
}
